import { HTTP, HTTP_FIREBASE_SHORTLINK } from '../../utils'

export const populateUserJwt = (data) => {
  return HTTP().post('/user/login/jwt', {})
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getAllChannels = () => {
  return HTTP().get('/channel/myChannels')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getPaginatedChannels = (page, count) => {
  return HTTP().get('/channel/admin/myChannels?page=' + page + '&count=' + count)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getChannelDetailByExternalId = (externalId) => {
  return HTTP().get('/channel/findByExternalId/' + externalId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getChannelDetail = (uuid) => {
  return HTTP().get('/channel/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const addParticipant = (uuid, usr) => {
  return HTTP().put('/channel/' + uuid + '/add', usr)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const deleteParticipant = (uuid, usr) => {
  return HTTP().put('/channel/' + uuid + '/remove', usr)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const createChannel = (data) => {
  let url = '/channel'
  if (data.uuid) {
    url += '/' + data.uuid
  }
  return HTTP().put(url, data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getAdvisorChannels = (externalIdStartWith) => {
  return HTTP().get('/channel/advisor/' + externalIdStartWith)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getRecommendationsAndNotificationsFromAllChannels = () => {
  return HTTP().get('/channel/student/myChannels/recommendationsAndNotifications')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const deleteMultipleChannels = (uuids) => {
  return HTTP().delete('channel/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const uploadFileAttachment = (data) => {
  let url = 'v1/shortLinks?key=AIzaSyBvbgnksPKifXn5ymgQ6ahfcITv25ULGRc'
  return HTTP_FIREBASE_SHORTLINK().post(url, data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCourseSectionChannel = (courseSectionId) => {
  return HTTP().get('channel/courseSection/' + courseSectionId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createStudyGroup = (channelId, data) => {
  let url = '/channel/' + channelId + '/createStudyGroup'
  return HTTP().put(url, data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const deleteStudyGroup = (channelId, groupId) => {
  return HTTP().get('/channel/' + channelId + '/deleteStudyGroup/' + groupId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getAllBadWords = () => {
  return HTTP().get('/badWord/list')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getParticipantDisplayNames = (uuids) => {
  return HTTP().put('user/displayNamesForSelectedUsers', uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getDirectChannelUsers = (courseId) => {
  return HTTP().get('/deliverycontext/directChannelUsers?courseId=' + courseId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getDirectChannelPeerMap = () => {
  return HTTP().get('user/fetchDirectChannelPeerMap')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const addToDirectChannelPeerMap = (selectedUsers) => {
  return HTTP().put('user/addToDirectChannelPeerMap', selectedUsers)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateDirectChannelPeerMap = (selectedUserId) => {
  return HTTP().get('user/' + selectedUserId + '/updateDirectChannelPeerMap')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getPlanningStreamIdsForSelectedUsers = (uuids) => {
  return HTTP().put('user/planningStreamIdsForSelectedUsers', uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getAdvisorChannelIdsForSelectedUsers = (uuids) => {
  return HTTP().put('channel/advisorChannelIdsForSelectedUsers', uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}



// WEBPACK FOOTER //
// ./src/app/channel/api.js